/* Magic In Home — Product page interactions
 * Gallery, variant sync, sticky ATC. Vanilla JS, defer-loaded. */

(function () {
  'use strict';

  const root = document.querySelector('[data-mih-product]');
  if (!root) return;

  const form = root.querySelector('.mih-product__form--js');
  const variantSelect = root.querySelector('[data-mih-variant-select]');
  const optionInputs = root.querySelectorAll('[data-mih-option-input]');
  const currentPriceEl = root.querySelector('[data-mih-current-price]');
  const comparePriceEl = root.querySelector('[data-mih-compare-price]');
  const atcBtn = root.querySelector('[data-mih-atc]');
  const atcLabel = root.querySelector('[data-mih-atc-label]');
  const buyNowBtn = root.querySelector('[data-mih-buynow]');
  const stickyBar = root.querySelector('[data-mih-sticky-atc]');
  const stickyPrice = root.querySelector('[data-mih-sticky-price]');
  const stickyBtn = root.querySelector('[data-mih-sticky-atc-btn]');

  // ---------- Gallery ----------
  const galleryRoot = root.querySelector('[data-mih-gallery]');
  if (galleryRoot) {
    const mainImages = galleryRoot.querySelectorAll('.mih-product__img');
    const thumbs = galleryRoot.querySelectorAll('[data-mih-thumb]');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const idx = parseInt(thumb.dataset.mihThumb, 10);
        mainImages.forEach((el, i) => {
          el.classList.toggle('is-active', i === idx);
          // Pause any video that just left the active slot.
          if (i !== idx && el.tagName === 'VIDEO') {
            try { el.pause(); } catch (_) {}
          }
        });
        thumbs.forEach((t) => {
          t.classList.toggle('is-active', t === thumb);
          t.setAttribute('aria-selected', t === thumb ? 'true' : 'false');
        });
      });
    });
  }

  // ---------- Variant sync ----------
  function getSelectedOptions() {
    const opts = {};
    optionInputs.forEach((input) => {
      if (input.checked) {
        const match = input.name.match(/options\[(.+)\]/);
        if (match) opts[match[1]] = input.value;
      }
    });
    return opts;
  }

  function syncVariant() {
    if (!variantSelect) return;
    const selected = getSelectedOptions();
    const titleParts = Object.values(selected);
    const targetTitle = titleParts.join(' / ');

    let matched = null;
    Array.from(variantSelect.options).forEach((opt) => {
      // Compare against the visible "title" prefix in option text
      if (opt.text.split(' - ')[0].trim() === targetTitle) matched = opt;
    });

    if (!matched) return;
    variantSelect.value = matched.value;

    // ---------- Image switch (variant → gallery) ----------
    const imgPos = parseInt(matched.dataset.imagePosition, 10);
    if (!isNaN(imgPos) && imgPos >= 0 && galleryRoot) {
      const mainImgs = galleryRoot.querySelectorAll('.mih-product__img');
      const thumbsAll = galleryRoot.querySelectorAll('[data-mih-thumb]');
      if (mainImgs[imgPos]) {
        mainImgs.forEach((img, i) => img.classList.toggle('is-active', i === imgPos));
        thumbsAll.forEach((t) => {
          const tIdx = parseInt(t.dataset.mihThumb, 10);
          t.classList.toggle('is-active', tIdx === imgPos);
          t.setAttribute('aria-selected', tIdx === imgPos ? 'true' : 'false');
        });
      }
    }

    // Price
    const price = matched.dataset.price;
    const compare = matched.dataset.comparePrice;
    const available = matched.dataset.available === 'true';

    if (currentPriceEl && price) currentPriceEl.textContent = price;
    if (comparePriceEl && compare && compare !== price) {
      comparePriceEl.textContent = compare;
      comparePriceEl.style.display = '';
    } else if (comparePriceEl) {
      comparePriceEl.style.display = 'none';
    }
    if (stickyPrice && price) stickyPrice.textContent = price;

    // Selected option labels (MIH-style "Colours : Brown")
    optionInputs.forEach((input) => {
      if (!input.checked) return;
      const pos = input.closest('[data-mih-option-position]');
      if (!pos) return;
      const valueEl = pos.querySelector('[data-mih-option-value]');
      const display = input.dataset.mihDisplayLabel || input.value;
      if (valueEl) valueEl.textContent = ': ' + display;
    });

    // Availability
    if (atcBtn) {
      atcBtn.disabled = !available;
      if (atcLabel) atcLabel.innerHTML = available ? atcLabel.innerHTML.replace(/Sold out/i, 'Add to cart') || atcLabel.innerHTML : 'Sold out';
    }
    if (buyNowBtn) buyNowBtn.disabled = !available;

    // URL update without reload
    const url = new URL(window.location.href);
    url.searchParams.set('variant', matched.value);
    history.replaceState({}, '', url.toString());
  }

  optionInputs.forEach((input) => input.addEventListener('change', syncVariant));

  // ---------- Buy it now → submit with intent ----------
  if (buyNowBtn && form) {
    buyNowBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const action = form.action;
      form.action = action; // ensure
      // Native cart-add then redirect to checkout via Shopify's standard pattern
      const fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then(() => { window.location.href = '/checkout'; })
        .catch(() => { form.submit(); });
    });
  }

  // ---------- AJAX add to cart (graceful) ----------
  if (form && atcBtn) {
    form.addEventListener('submit', (e) => {
      // If browser supports fetch, intercept; otherwise let native form post
      if (!window.fetch) return;
      e.preventDefault();
      const fd = new FormData(form);
      atcBtn.classList.add('is-loading');
      atcBtn.disabled = true;
      const originalLabel = atcLabel ? atcLabel.innerHTML : '';
      if (atcLabel) atcLabel.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((data) => {
          if (data && data.status && data.status !== 200) {
            if (atcLabel) atcLabel.textContent = data.description || 'Not available';
            atcBtn.classList.remove('is-loading');
            atcBtn.disabled = false;
            setTimeout(() => { if (atcLabel) atcLabel.innerHTML = originalLabel; }, 2500);
            return;
          }
          if (atcLabel) atcLabel.innerHTML = '✓ Added to cart';
          atcBtn.classList.remove('is-loading');
          atcBtn.disabled = false;
          // Notify any cart drawer in the parent theme
          document.dispatchEvent(new CustomEvent('mih:cart:added', { detail: data }));
          window.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(() => { if (atcLabel) atcLabel.innerHTML = originalLabel; }, 2500);
        })
        .catch(() => {
          // Fallback: submit form natively
          atcBtn.disabled = false;
          atcBtn.classList.remove('is-loading');
          form.submit();
        });
    });
  }

  // ---------- Sticky ATC visibility ----------
  if (stickyBar) {
    const mainAtc = atcBtn;
    if (mainAtc && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
            stickyBar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
          });
        },
        { rootMargin: '0px 0px -100px 0px' }
      );
      io.observe(mainAtc);
    }
    if (stickyBtn && form) {
      stickyBtn.addEventListener('click', () => {
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });
    }
  }
})();

